import { PartnerController } from './Controllers/partner'

export class PostpaidPartnerService {
  static PartnerController = PartnerController
}
